import { logger } from '@/logger.js';

/** The pdf.js module, as `loadPdfjs` resolves it. */
export type PdfjsModule = typeof import('pdfjs-dist');

/**
 * Load pdf.js on demand and point it at its worker bundle. The worker URL is a process-wide setting, so
 * it is written only while pdf.js has none: a value set earlier, by this module or by anyone else, is
 * kept, and a resolution that failed is tried again on the next call. A failure only costs speed —
 * pdf.js then parses on the main thread — so it is logged rather than thrown.
 */
export async function loadPdfjs(): Promise<PdfjsModule> {
  const pdfjs = await import('pdfjs-dist');
  if (pdfjs.GlobalWorkerOptions.workerSrc) return pdfjs;
  try {
    pdfjs.GlobalWorkerOptions.workerSrc = new URL(
      'pdfjs-dist/build/pdf.worker.mjs',
      import.meta.url,
    ).href;
  } catch (error: unknown) {
    logger.warn('pdfjs: pdf.worker resolve failed', error);
  }
  return pdfjs;
}
